import type { EhrMemberMatch } from "../graphql/resolveEhrMember";

export type ResolutionState =
  | { kind: "idle" }
  | { kind: "resolving" }
  | { kind: "none" }
  | { kind: "single"; member: EhrMemberMatch }
  | { kind: "multiple"; members: EhrMemberMatch[] }
  | { kind: "error"; message: string };

export interface ResolutionInputs {
  ehrPatientId?: string;
  resolvedForId?: string;
  loading: boolean;
  error?: string | null;
  matches: EhrMemberMatch[];
}

export function deriveResolutionState(input: ResolutionInputs): ResolutionState {
  const { ehrPatientId, resolvedForId, loading, error, matches } = input;
  if (!ehrPatientId) return { kind: "idle" };
  if (loading || resolvedForId !== ehrPatientId) return { kind: "resolving" };
  if (error) return { kind: "error", message: error };
  if (matches.length === 0) return { kind: "none" };
  if (matches.length === 1) return { kind: "single", member: matches[0] };
  return { kind: "multiple", members: matches };
}
